import { validateUserRow } from './draftRowValidation';
import type { ParsedUser } from './excelParsers';
import { fillGapsByKey } from './fillGapsByKey';

const FILLED_FIELDS = ['department', 'role'] as const;

/**
 * Merges the data-sync people into the rows on screen. A person matches an
 * on-screen row by email only, and fills just that row's empty department and
 * Stelle: names, emails and placements the admin sees or entered stay, so a
 * protected row's locked identity is never touched either. An unmatched person
 * appends. Returns the current rows unchanged when nothing changed.
 */
export function mergeSetupUsers(current: ParsedUser[], imported: ParsedUser[]): ParsedUser[] {
  return fillGapsByKey(current, imported, {
    keyOf: (data) => data.email,
    fields: FILLED_FIELDS,
    validate: validateUserRow
  });
}
